import React from 'react'

export default () => {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3108_3872)">
        <rect width="44" height="44" fill="white" />
        <rect width="44" height="44" fill="#032942" />
        <g>
          <path
            d="M-0.467773 7.95718L1.17052 9.36144L4.79818 15.3295L7.25563 17.6699L7.95776 19.0742"
            stroke="#032942"
            strokeWidth=".8"
          />
          <path
            d="M28.4365 15.4467L34.4046 19.5424H36.0429L44.0004 24.4573"
            stroke="#032942"
            strokeWidth=".8"
          />
          <path
            d="M7.95743 -0.117289L8.8936 3.74441L8.65955 5.96782L9.4787 6.66994L10.2979 5.38271L11.9362 6.66994V7.95718L14.0425 11.3508L11.4681 12.521V13.4572L13.2234 14.2763L14.0425 15.9146L13.2234 17.0848M13.2234 17.0848V17.5529H11.9362L3.9787 20.5955L2.92551 23.1699H-0.702148M13.2234 17.0848L14.7447 18.021L16.2659 19.1912L16.734 19.8933L17.5532 19.1912L17.9042 15.9146L21.6489 17.0848L21.4149 14.0423L22.9362 14.6274M22.9362 14.6274L25.0425 13.1061L26.9149 9.24441L26.3298 5.96782L27.383 5.03165L31.7127 3.74441L30.6596 -0.117289L31.4787 -0.468353M22.9362 14.6274V15.5636L24.3404 19.1912M24.3404 19.1912L44.234 0.584838M24.3404 19.1912H25.7447L26.3298 20.7125L25.7447 21.2976L25.0425 22.4678H23.7553L23.4042 22.9359L24.1064 24.1061L23.7553 26.0955M23.7553 26.0955L22.9362 30.1912L24.1064 33.1168L23.4042 34.287L20.4787 35.3402L19.0744 36.8614L19.4255 40.138L21.1808 44.2338M23.7553 26.0955L36.7447 32.8827L37.7979 31.8295L44.117 36.5104"
            stroke="#CBB3FD"
            strokeWidth=".8"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3108_3872">
          <rect width="44" height="44" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
